(function(){
    var eperSpread = {};
    eperSpread.CookieKey = "Eper-Spread";
    eperSpread.CookieDomain = ".epermarket.com";
    eperSpread.CookieExpiredDays = 7;
    eperSpread.getUrl = function(){
        return window.location.href;
    };
    eperSpread.getNowUtcTime = function(){
        var d = new Date();
        return Math.floor(d.getTime() /1000);
    };
    eperSpread.setCookie = function(name,msg,expireDays){
        var exp = new Date();
        exp.setTime(exp.getTime() + expireDays * 86400000); // 86400000 = 24 * 60 * 60 * 1000;
        document.cookie = name + "=" + msg + ";expires=" + exp.toGMTString() + ";domain="+eperSpread.CookieDomain+"; path=/";
    };
    eperSpread.getRequest = function() {
        var url = location.search; //获取url中"?"符后的字串 
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    }
    eperSpread.init = function () {
        var spreadNo = "";

        var req = eperSpread.getRequest();
        if (!!!req || !!!req.spreadno) {
            return;
        }
        spreadNo = req.spreadno;
        var url = eperSpread.getUrl();
        var time = eperSpread.getNowUtcTime();
        var obj = {
            spreadNo: spreadNo,
            url: url,
            time: time
        };
        eperSpread.setCookie(eperSpread.CookieKey, JSON.stringify(obj), eperSpread.CookieExpiredDays);
    }
    try {
        eperSpread.init();
    }
    catch (err) {
      //  console.log("eper-spread error");
      //  console.log(err);
    }    
})();




// WEBPACK FOOTER //
// ./src/plugins/eper-spread.js